import React from 'react';

import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import {twx} from '@/utils/tailwindUtils';

import DevicesSettingsSectionNew from '../DevicesSettingsSection/DevicesSettingsSectionNew';
import useDeviceSettingsContent from './hooks/useDeviceSettingsContent';
import {AutoStartButton} from './views/AutoStart';
import {FlexPuffButton} from './views/FlexPuff';
import IlluminationModeButton from './views/IlluminationMode/IlluminationModeButton';

const getComponentByType = (type) => {
    switch (type) {
        case AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE:
            return IlluminationModeButton;
        case AEM_DEVICE_SETTINGS_TYPES.FLEX_PUFF:
            return FlexPuffButton;
        case AEM_DEVICE_SETTINGS_TYPES.AUTO_START:
            return AutoStartButton;
        default:
            return null;
    }
};

const DeviceSettings = ({className}) => {
    const isDesktopLayout = useIsDesktopLayout();
    const {settings} = useDeviceSettingsContent();

    if (!settings?.length) return null;

    return settings.map((group, i) => {
        const {title, items} = group;

        return (
            <DevicesSettingsSectionNew.Group key={i} className={className}>
                <DevicesSettingsSectionNew.Title text={title} />
                <div
                    className={twx({
                        'flex w-full flex-col overflow-hidden rounded-xl bg-romance': !isDesktopLayout,
                        'ml:grid ml:grid-cols-2 ml:gap-2': isDesktopLayout,
                    })}
                >
                    {items.map((item, i) => {
                        const Component = getComponentByType(item.type);

                        if (!Component) return null;

                        return <Component key={i} content={item} isLast={i === items.length - 1} />;
                    })}
                </div>
            </DevicesSettingsSectionNew.Group>
        );
    });
};

export default DeviceSettings;
